import React from 'react'

import './styles.scss'
export interface Props {
  statement: string
  direction: string
}

export const Statement = ({ statement, direction }: Props) => {
  return (
    <>
      {direction === 'left' ? (
        <>
          <div className='statement left'>
            <div className='bg'>
              <div className='arrow'>
                <img src='images/arrow.svg' />
              </div>
              <div className='text'>«{statement}»</div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className='statement right'>
            <div className='bg'>
              <div className='arrow'>
                <img src='images/arrow.svg' />
              </div>
              <div className='text'>«{statement}»</div>
            </div>
          </div>
        </>
      )}
    </>
  )
}
